export const weekDayByName = {
  sunday: 0,
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6
}

export const conversionMessages = {
  BAD: {
    COLOR: '#FF6666',
    MESSAGE: 'O número de conversões está ruim.'
  },
  GOOD: {
    COLOR: '#fac679',
    MESSAGE: 'O número de conversões está na média.'
  },
  EXCELLENT: {
    COLOR: '#70DD67',
    MESSAGE: 'O número de conversões está excelente!'
  }
}

export const MODALITY_TYPE = {
  FLOW_ACTION: 'ACAO_DE_FLUXO',
  BOTI_RECICLA: 'BOTIRECICLA',
  MASSIVE_SAMPLING: 'AMOSTRAGEM_MASSIVA',
  RAFFLE: 'SORTEIO',
  CASHBACK: 'CASHBACK',
  INDICATION: 'INDICACAO'
}

export const CAMPAIGN_TYPE = {
  WHATSAPP: 'Whatsapp',
  FISICAL: 'Fisica'
}

export const BRANCH_TYPES = {
  BOT: {
    acron: 'BOT',
    name: 'O Boticário',
    fidelity: 'Beautybox'
  },
  QDB: {
    acron: 'QDB',
    name: 'Quem Disse, Berenice?',
    fidelity: 'Beautybox'
  }
}

export const LOGIN_TYPES = {
  mktadmin: 'mkt-admin',
  cplv: 'cplv',
  cplvonerror: 'cplv-on-error',
  identity: 'identity'
}

export const LoginTypePossibility = (type = '') => {
  const { REACT_APP_LOGIN_BY = '' } = window?.env || {}

  const LoginPossibititiesOnEviroment = String(REACT_APP_LOGIN_BY)
    .split(',')
    .map((possibility) => possibility.trim())

  return LoginPossibititiesOnEviroment.includes(type)
}

